import { render, staticRenderFns } from "./EditModelPart.vue?vue&type=template&id=128d0a9e&"
import script from "./EditModelPart.vue?vue&type=script&lang=js&"
export * from "./EditModelPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports